import {
  expenseInputTypes,
  customFieldDataTypes,
  EXPENSE_ACTION_TYPES,
  EXPENSE_FORM_KEYS,
  searchTypesEnum,
} from './Enums';

export const DynamoDBFieldNames = {
  AMOUNT: 'Amount',
  CHARGE_DATE: 'ChargeDate',
  CURRENCY: 'Currency',
  DEPARTURE_DATE: 'DepartureDate',
  CHECK_IN_DATE: 'CheckInDate',
  EXPENSE_CATEGORY: 'ExpenseCategory',
  EXPENSE_DATE: 'ExpenseDate',
  EXPENSE_SUB_CATEGORY: 'ExpenseSubCategory',
  HAS_BILLABLE: 'HasBillable',
  INVOICE_NUMBER: 'InvoiceNumber',
  LOCATION_FROM: 'LocationFrom',
  LOCATION_TO: 'LocationTo',
  LOCATION: 'Location',
  PICKUP_ADDRESS: 'PickupAddress',
  DROP_OFF_ADDRESS: 'DropoffAddress',
  MERCHANT: 'Merchant',
  PAYMENT_TYPE: 'PaymentType',
  PURPOSE: 'Purpose',
  RECEIPTS: 'Receipts',
  REIMBURSABLE: 'Reimbursable',
  REPORT_ID: 'ReportId',
  TICKET_NUMBER: 'TicketNumber',
  PARTICIPANTS: 'Participants',
  CLIENT: 'Client',
  SELECTED_SUBCATEGORY: 'SELECTED_SUBCATEGORY',
  MILEAGE_LOCATION_FROM: 'MilageLocationFrom',
  MILEAGE_LOCATION_TO: 'MilageLocationTo',
  DISTANCE: 'Distance',
  RATE: 'Rate',
  DISTANCE_RATE: 'DistanceRate',
};

const {
  TEXT_ENTRY,
  PULL_DOWN,
  MONEY,
  AUTO_COMPLETE,
  PARTICIPANT,
  PAYMENT_TYPE,
} = expenseInputTypes;

const {
  ALPHABET,
  ALPHA_NUMERIC,
  NUMERIC,
  EMAIL,
  ALPHA_NUMERIC_WITH_SPACE,
  ALPHA_NUMERIC_WITH_SPECIAL_CHAR,
  DATE_TIME,
} = customFieldDataTypes;

export const TOGGLE_KEYS = [
  { key: DynamoDBFieldNames.REIMBURSABLE, label: 'Reimbursable' },
  { key: DynamoDBFieldNames.HAS_BILLABLE, label: 'Billable' },
];

export const REPORT_TOGGLE_OPTIONS = {
  NEW_REPORT: { label: 'New Report', value: '0' },
  EXISTING: { label: 'Existing' },
};

export const DEFAULT_PAYMENT_TYPE = {
  text: '--Select--',
  value: -1,
};

export const REPORT_TOGGLE_KEY = 'reportToggle';

export const LAYOUT = {
  SINGLE_COLUMN: 1, // Occupies 1 column in a 2-column layout
  FULL_WIDTH: 2, // Occupies 2 columns in a 2-column layout
  SINGLE_HEIGHT: 1, // Occupies 1 row in the layout
  DOUBLE_HEIGHT: 2, // Occupies 2 rows in the layout
};
const dateConfig = {
  inputType: TEXT_ENTRY,
  format: DATE_TIME,
};
const MERCHANT_FIELD = {
  inputConfig: {
    inputType: TEXT_ENTRY,
    format: ALPHA_NUMERIC_WITH_SPECIAL_CHAR,
  },
  placeholder: 'Merchant',
  stateName: DynamoDBFieldNames.MERCHANT,
  icon: 'building',
  mandatory: {
    [EXPENSE_ACTION_TYPES.CREATION]: true,
    [EXPENSE_ACTION_TYPES.UPDATE]: true,
  },
  layoutConfig: {
    span: LAYOUT.FULL_WIDTH,
  },
};
const DESCRIBE_FIELD = {
  inputConfig: {
    inputType: TEXT_ENTRY,
    format: ALPHA_NUMERIC_WITH_SPECIAL_CHAR,
  },
  placeholder: 'Describe',
  stateName: DynamoDBFieldNames.PURPOSE,
  icon: 'message',
  mandatory: {
    [EXPENSE_ACTION_TYPES.CREATION]: true,
    [EXPENSE_ACTION_TYPES.UPDATE]: true,
  },
  layoutConfig: {
    span: LAYOUT.FULL_WIDTH,
    rowSpan: LAYOUT.DOUBLE_HEIGHT, // Double height (2 rows)
  },
};
const DEPARTURE_DATE_FIELD = {
  inputConfig: dateConfig,
  placeholder: 'Departure Date',
  stateName: DynamoDBFieldNames.DEPARTURE_DATE,
  icon: 'calendar',
  mandatory: {
    [EXPENSE_ACTION_TYPES.CREATION]: true,
    [EXPENSE_ACTION_TYPES.UPDATE]: true,
  },
  layoutConfig: {
    span: LAYOUT.FULL_WIDTH,
  },
};
const TICKET_NUMBER_FIELD = {
  inputConfig: {
    inputType: TEXT_ENTRY,
    format: ALPHA_NUMERIC,
  },
  placeholder: 'Ticket #',
  stateName: DynamoDBFieldNames.TICKET_NUMBER,
  icon: 'boardingPass',
  mandatory: {
    [EXPENSE_ACTION_TYPES.CREATION]: false,
    [EXPENSE_ACTION_TYPES.UPDATE]: false,
  },
  layoutConfig: {
    span: LAYOUT.FULL_WIDTH,
  },
};

const PARTICIPANTS_FIELD = {
  inputConfig: {
    inputType: PARTICIPANT,
  },
  placeholder: 'Participants',
  stateName: DynamoDBFieldNames.PARTICIPANTS,
  icon: 'person',
  mandatory: {
    [EXPENSE_ACTION_TYPES.CREATION]: true,
    [EXPENSE_ACTION_TYPES.UPDATE]: true,
  },
  layoutConfig: {
    span: LAYOUT.FULL_WIDTH,
  },
};

const COMMON_MONEY_FIELD = {
  inputConfig: {
    inputType: MONEY,
  },
  placeholder: 'Amount',
  stateName: DynamoDBFieldNames.AMOUNT,
  currencyStateName: DynamoDBFieldNames.CURRENCY,
  icon: null,
  mandatory: {
    [EXPENSE_ACTION_TYPES.CREATION]: true,
    [EXPENSE_ACTION_TYPES.UPDATE]: true,
  },
  layoutConfig: {
    span: LAYOUT.SINGLE_COLUMN,
  },
};

const PAYMENT_FIELDS = [
  {
    inputConfig: {
      inputType: PAYMENT_TYPE,
      options: [DEFAULT_PAYMENT_TYPE.text],
    },
    placeholder: 'Payment',
    stateName: DynamoDBFieldNames.PAYMENT_TYPE,
    icon: 'payment_type',
    mandatory: {
      [EXPENSE_ACTION_TYPES.CREATION]: true,
      [EXPENSE_ACTION_TYPES.UPDATE]: true,
    },
    layoutConfig: {
      span: LAYOUT.SINGLE_COLUMN,
    },
  },
  COMMON_MONEY_FIELD,
];

const COMMON_FIELDS = [
  {
    inputConfig: dateConfig,
    placeholder: 'Charge Date',
    stateName: DynamoDBFieldNames.CHARGE_DATE,
    icon: 'calendar',
    mandatory: {
      [EXPENSE_ACTION_TYPES.CREATION]: true,
      [EXPENSE_ACTION_TYPES.UPDATE]: true,
    },
    layoutConfig: {
      span: LAYOUT.FULL_WIDTH,
    },
  },
  PAYMENT_FIELDS[0],
  PAYMENT_FIELDS[1],
];

const LOCATION_FIELD = {
  inputConfig: {
    inputType: AUTO_COMPLETE,
    searchType: searchTypesEnum.HOTEL,
  },
  placeholder: 'Location',
  stateName: DynamoDBFieldNames.LOCATION,
  icon: 'mark',
  mandatory: {
    [EXPENSE_ACTION_TYPES.CREATION]: true,
    [EXPENSE_ACTION_TYPES.UPDATE]: true,
  },
  layoutConfig: {
    span: LAYOUT.FULL_WIDTH,
  },
};

const buildFieldsForFirstScreen = (merchantPlaceholder) => [
  { ...MERCHANT_FIELD, placeholder: merchantPlaceholder },
  ...COMMON_FIELDS,
];

const defaultFormFields = {
  [EXPENSE_FORM_KEYS.STEP_ONE]: buildFieldsForFirstScreen('Merchant'),
  [EXPENSE_FORM_KEYS.STEP_TWO]: [DESCRIBE_FIELD],
};

export const CAR_RENTAL_SUB_CATEGORY_ID = 2;
export const MILEAGE_CATEGORY = {
  CategoryId: 4,
  SubCategoryId: 15,
};

export const DEFAULT_SELECT_SUBCATEGORY = {
  SubCategoryId: 0,
  Name: '--Select--',
  formFields: defaultFormFields,
};

export const DEFAULT_CATEGORY = {
  CategoryId: 0,
  GroupName: '',
  SubCategories: [DEFAULT_SELECT_SUBCATEGORY],
};

const AirFareFormFields = {
  [EXPENSE_FORM_KEYS.STEP_ONE]: buildFieldsForFirstScreen('Airline'),
  [EXPENSE_FORM_KEYS.STEP_TWO]: [
    DESCRIBE_FIELD,
    DEPARTURE_DATE_FIELD,
    TICKET_NUMBER_FIELD,
    {
      inputConfig: {
        inputType: AUTO_COMPLETE,
        searchType: searchTypesEnum.AIR,
      },
      placeholder: 'From',
      stateName: DynamoDBFieldNames.LOCATION_FROM,
      icon: 'mark',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.SINGLE_COLUMN,
      },
    },
    {
      inputConfig: {
        inputType: AUTO_COMPLETE,
        searchType: searchTypesEnum.AIR,
      },
      placeholder: 'To',
      stateName: DynamoDBFieldNames.LOCATION_TO,
      icon: 'mark',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.SINGLE_COLUMN,
      },
    },
  ],
};

const RailFormFields = {
  [EXPENSE_FORM_KEYS.STEP_ONE]: buildFieldsForFirstScreen('Rail Service'),
  [EXPENSE_FORM_KEYS.STEP_TWO]: [
    DESCRIBE_FIELD,
    DEPARTURE_DATE_FIELD,
    TICKET_NUMBER_FIELD,
    {
      inputConfig: {
        inputType: TEXT_ENTRY,
        format: ALPHA_NUMERIC_WITH_SPECIAL_CHAR,
      },
      placeholder: 'From',
      stateName: DynamoDBFieldNames.LOCATION_FROM,
      icon: 'mark',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.SINGLE_COLUMN,
      },
    },
    {
      inputConfig: {
        inputType: TEXT_ENTRY,
        format: ALPHA_NUMERIC_WITH_SPECIAL_CHAR,
      },
      placeholder: 'To',
      stateName: DynamoDBFieldNames.LOCATION_TO,
      icon: 'mark',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.SINGLE_COLUMN,
      },
    },
  ],
};

const ClientMealFormFields = {
  [EXPENSE_FORM_KEYS.STEP_ONE]: buildFieldsForFirstScreen('Merchant'),
  [EXPENSE_FORM_KEYS.STEP_TWO]: [
    DESCRIBE_FIELD,
    PARTICIPANTS_FIELD,
    {
      inputConfig: {
        inputType: TEXT_ENTRY,
        format: ALPHA_NUMERIC_WITH_SPECIAL_CHAR,
      },
      placeholder: 'Client',
      stateName: DynamoDBFieldNames.CLIENT,
      icon: 'building',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.FULL_WIDTH,
      },
    },
    {
      inputConfig: {
        inputType: AUTO_COMPLETE,
        searchType: searchTypesEnum.HOTEL,
      },
      placeholder: 'Location',
      stateName: DynamoDBFieldNames.LOCATION,
      icon: 'mark',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.FULL_WIDTH,
      },
    },
  ],
};

const EmployeeMealFormFields = {
  [EXPENSE_FORM_KEYS.STEP_ONE]: buildFieldsForFirstScreen('Merchant'),
  [EXPENSE_FORM_KEYS.STEP_TWO]: [
    DESCRIBE_FIELD,
    PARTICIPANTS_FIELD,
    {
      inputConfig: {
        inputType: AUTO_COMPLETE,
        searchType: searchTypesEnum.HOTEL,
      },
      placeholder: 'Location',
      stateName: DynamoDBFieldNames.LOCATION,
      icon: 'mark',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.FULL_WIDTH,
      },
    },
  ],
};

const HotelStayFormFields = {
  [EXPENSE_FORM_KEYS.STEP_ONE]: [
    MERCHANT_FIELD,
    {
      inputConfig: dateConfig,
      placeholder: 'Charge Date',
      stateName: DynamoDBFieldNames.CHARGE_DATE,
      icon: 'calendar',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: false,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.FULL_WIDTH,
      },
    },
    PAYMENT_FIELDS[0],
    PAYMENT_FIELDS[1],
  ],
  [EXPENSE_FORM_KEYS.STEP_TWO]: [
    DESCRIBE_FIELD,
    {
      inputConfig: dateConfig,
      placeholder: 'Check-in Date',
      stateName: DynamoDBFieldNames.CHECK_IN_DATE,
      icon: 'calendar',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.FULL_WIDTH,
      },
    },
    LOCATION_FIELD,
  ],
};

const CarRentalFormFields = {
  [EXPENSE_FORM_KEYS.STEP_ONE]: HotelStayFormFields[EXPENSE_FORM_KEYS.STEP_ONE],
  [EXPENSE_FORM_KEYS.STEP_TWO]: [
    DESCRIBE_FIELD,
    {
      inputConfig: dateConfig,
      placeholder: 'Pickup Date',
      stateName: DynamoDBFieldNames.DEPARTURE_DATE,
      icon: 'calendar',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.FULL_WIDTH,
      },
    },
    {
      inputConfig: {
        inputType: AUTO_COMPLETE,
        searchType: searchTypesEnum.CAR,
      },
      placeholder: 'Pickup',
      stateName: DynamoDBFieldNames.PICKUP_ADDRESS,
      icon: 'mark',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.SINGLE_COLUMN,
      },
    },
    {
      inputConfig: {
        inputType: AUTO_COMPLETE,
        searchType: searchTypesEnum.CAR,
      },
      placeholder: 'Dropoff',
      stateName: DynamoDBFieldNames.DROP_OFF_ADDRESS,
      icon: 'mark',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.SINGLE_COLUMN,
      },
    },
  ],
};

const RideShareFormFields = {
  [EXPENSE_FORM_KEYS.STEP_ONE]: buildFieldsForFirstScreen('Merchant'),
  [EXPENSE_FORM_KEYS.STEP_TWO]: [DESCRIBE_FIELD, LOCATION_FIELD],
};

const ServiceFeesFormFields = {
  [EXPENSE_FORM_KEYS.STEP_ONE]: buildFieldsForFirstScreen('Name of Provider'),
  [EXPENSE_FORM_KEYS.STEP_TWO]: [DESCRIBE_FIELD],
};

export const MileageAddressFormFields = {
  [EXPENSE_FORM_KEYS.STEP_ONE]: [
    {
      inputConfig: {
        inputType: AUTO_COMPLETE,
        searchType: searchTypesEnum.CAR,
      },
      placeholder: 'From',
      stateName: DynamoDBFieldNames.MILEAGE_LOCATION_FROM,
      icon: 'mark',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.SINGLE_COLUMN,
      },
    },
    {
      inputConfig: {
        inputType: AUTO_COMPLETE,
        searchType: searchTypesEnum.CAR,
      },
      placeholder: 'To',
      stateName: DynamoDBFieldNames.MILEAGE_LOCATION_TO,
      icon: 'mark',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.SINGLE_COLUMN,
      },
    },
    {
      inputConfig: {
        inputType: TEXT_ENTRY,
        format: NUMERIC,
      },
      placeholder: 'Distance',
      stateName: DynamoDBFieldNames.DISTANCE,
      icon: 'mark',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.SINGLE_COLUMN,
      },
    },
    {
      inputConfig: dateConfig,
      placeholder: 'Date',
      stateName: DynamoDBFieldNames.CHARGE_DATE,
      icon: 'calendar',
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.SINGLE_COLUMN,
      },
    },
    {
      inputConfig: {
        inputType: MONEY,
      },
      placeholder: 'Rate',
      stateName: DynamoDBFieldNames.RATE,
      currencyStateName: DynamoDBFieldNames.DISTANCE_RATE,
      icon: null,
      mandatory: {
        [EXPENSE_ACTION_TYPES.CREATION]: true,
        [EXPENSE_ACTION_TYPES.UPDATE]: true,
      },
      layoutConfig: {
        span: LAYOUT.SINGLE_COLUMN,
      },
    },
    COMMON_MONEY_FIELD,
  ],
  [EXPENSE_FORM_KEYS.STEP_TWO]: [DESCRIBE_FIELD],
};

export const DEFAULT_MILEAGE_SUBCATEGORY = {
  SubCategoryId: 0,
  Name: '--Select--',
  formFields: MileageAddressFormFields,
};

export const DEFAULT_MILEAGE_CATEGORY = {
  CategoryId: 0,
  GroupName: '',
  SubCategories: [DEFAULT_MILEAGE_SUBCATEGORY],
};

export const MileageCategories = [
  DEFAULT_MILEAGE_CATEGORY,
  {
    CategoryId: 4,
    GroupName: 'Mileage',
    SubCategories: [{ SubCategoryId: 15, Name: 'Address', formFields: MileageAddressFormFields }],
  },
];

export const ExpenseCategories = [
  DEFAULT_CATEGORY,
  {
    CategoryId: 1,
    GroupName: 'Business Travel',
    SubCategories: [
      { SubCategoryId: 1, Name: 'Airfare', formFields: AirFareFormFields },
      {
        SubCategoryId: CAR_RENTAL_SUB_CATEGORY_ID,
        Name: 'Car Rental',
        formFields: CarRentalFormFields,
      },
      {
        SubCategoryId: 3,
        Name: 'Hotel Stay',
        formFields: HotelStayFormFields,
      },
      { SubCategoryId: 4, Name: 'Rail', formFields: RailFormFields },
      {
        SubCategoryId: 6,
        Name: 'Ride Share',
        formFields: RideShareFormFields,
      },
      {
        SubCategoryId: 7,
        Name: 'Service Fees',
        formFields: ServiceFeesFormFields,
      },
      { SubCategoryId: 8, Name: 'Airport Parking', formFields: defaultFormFields },
      { SubCategoryId: 19, Name: 'Fuel/Gas', formFields: defaultFormFields },
    ],
  },
  {
    CategoryId: 4,
    GroupName: 'General',
    SubCategories: [
      { SubCategoryId: 32, Name: 'Advertising', formFields: defaultFormFields },
      { SubCategoryId: 29, Name: 'Client Entertainment', formFields: defaultFormFields },
      { SubCategoryId: 34, Name: 'Client Event', formFields: defaultFormFields },
      { SubCategoryId: 33, Name: 'Conference', formFields: defaultFormFields },
      { SubCategoryId: 30, Name: 'Employee Entertainment', formFields: defaultFormFields },
      { SubCategoryId: 25, Name: 'Foreign Exchange', formFields: defaultFormFields },
      { SubCategoryId: 28, Name: 'Gifts', formFields: defaultFormFields },
      { SubCategoryId: 35, Name: 'Hardware & Hosting', formFields: defaultFormFields },
      { SubCategoryId: 20, Name: 'Internet/Online Fees', formFields: defaultFormFields },
      { SubCategoryId: 31, Name: 'Marketing', formFields: defaultFormFields },
      { SubCategoryId: 21, Name: 'Mobile Phones', formFields: defaultFormFields },
      { SubCategoryId: 22, Name: 'Office Supplies', formFields: defaultFormFields },
      { SubCategoryId: 23, Name: 'Other', formFields: defaultFormFields },
      { SubCategoryId: 24, Name: 'Software', formFields: defaultFormFields },
      { SubCategoryId: 27, Name: 'Tips', formFields: defaultFormFields },
      { SubCategoryId: 26, Name: 'Utilities', formFields: defaultFormFields },
    ],
  },
  {
    CategoryId: 2,
    GroupName: 'Meals',
    SubCategories: [
      { SubCategoryId: 13, Name: 'Client Meal', formFields: ClientMealFormFields },
      {
        SubCategoryId: 9,
        Name: 'Employee Meal',
        formFields: EmployeeMealFormFields,
      },
      { SubCategoryId: 12, Name: 'Office Snacks', formFields: defaultFormFields },
    ],
  },
];

// For further details check WebV5\react\components\UIElements\SelectItem.jsx in the WebV5 project
